module.exports = __webpack_public_path__ + "static/bg_all.fd44703d.png";